import { Avatar, Badge, Dropdown, Layout, theme, Menu } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { MenuProps } from "antd/es/menu/menu";
import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../../Utility/images/ease/transparent/ease-primary-white.webp";
import { DashboardOutlined, SettingOutlined, GoldOutlined, CommentOutlined, ShopOutlined, MenuOutlined, QuestionCircleOutlined, CloseOutlined, UserOutlined, TruckOutlined, FileTextOutlined, AppstoreOutlined, BankOutlined, BookOutlined, MessageOutlined, MailOutlined, BellOutlined, ToolOutlined, LineChartOutlined, BuildOutlined, ScheduleOutlined, ProjectOutlined, DollarCircleOutlined, FileDoneOutlined, MenuFoldOutlined, MenuUnfoldOutlined, DeleteOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { Persistor } from "../../redux/store";
import { getNotifications } from "../../redux/actions/API/notifications";
import "./Main.css";
import { jwtDecode } from "jwt-decode";
import noNotification from "../../Utility/images/nonotification.avif";

const BuyerSupplier = lazy(() => import("./manageCompany/Companies"));
const Dashboard = lazy(() => import("../../Dashboard/Components/Dashboard"));
const Settings = lazy(() => import("../../Dashboard/Components/manage-user/Usermanagement"));
const Usermanagement = lazy(() => import("../../Dashboard/Components/manage-user/Usermanagement"));
const Teammanagement = lazy(() => import("../../Dashboard/Components/teams/Teammanagement"));
const ProfileManagement = lazy(() => import("../../Dashboard/Components/profileManagement/ProfileManagement"));
import ManageBlogs from "../../Dashboard/Components/manage-blog/ManageBlogs";
import ViewBulkProduction from "../../Dashboard/Components/production-section/ViewBulkProduction";
import InventoryApproval from "../../Dashboard/Components/InventoryApproval/InventoryApproval";
import InventoryPreview from "../../Dashboard/Components/InventoryApproval/InventoryPreview";
import DeleteCompanyData from "../../Dashboard/Components/delete-company-data/DeleteCompanyData";
import GateEntries from "../../Dashboard/Components/gate-entry/GateEntries";
import PreviewGateEntry from "../../Dashboard/Components/gate-entry/PreviewGateEntry";
import CreateGateEntry from "../../Dashboard/Components/gate-entry/CreateGateEntry";
import StoreWiseItems from "../../Dashboard/Components/DashboardExtra/StoreWiseItems";
import CategoryWiseItems from "../../Dashboard/Components/DashboardExtra/CategoryWiseItems";
import StockAgeingItems from "../../Dashboard/Components/DashboardExtra/StockAgeingItems";
import StockLevelAnalysisItems from "../../Dashboard/Components/DashboardExtra/StockLevelAnalysisItems";
import OutOfStockItems from "../../Dashboard/Components/DashboardExtra/OutOfStockItems";
import FastSlowMovingItems from "../../Dashboard/Components/DashboardExtra/FastSlowMovingItems";
import OnTimeDelayProductionItems from "../../Dashboard/Components/DashboardExtra/OnTimeDelayProductionItems";
import WorkOrderStatusItems from "../../Dashboard/Components/DashboardExtra/WorkOrderStatusItems";
import SalesDashboardDetails from "../../Dashboard/Components/DashboardExtra/SalesDashboardDetails";
const Permissions = lazy(() => import("../../Dashboard/Components/profileManagement/Permissions"));
const ItemManagement = lazy(() => import("../../Dashboard/Components/itemManagement/ItemManagement"));
const StoresManagement = lazy(() => import("../../Dashboard/Components/storeMangement/StoresManagement"));
const CommentsCollections = lazy(() => import("../../Dashboard/Components/blog-comments/CommentsCollections"));
const Documents = lazy(() => import("../../Dashboard/Components/Documents/Documents"));
const CreateDocument = lazy(() => import("../../Dashboard/Components/Documents/CreateDocument"));
const PreviewDocument = lazy(() => import("../../Dashboard/Components/previewDocument/PreviewDocument"));
const ServiceDocument = lazy(() => import("../../Dashboard/Components/servicepreviewDocument/PreviewDocument"));
const Integrations = lazy(() => import("../../Dashboard/Components/Integrations"));
const Transaction = lazy(() => import("../../Dashboard/Components/Transaction/Transaction"));
const Reports = lazy(() => import("../../Dashboard/Components/Reports/Reports"));
const Timeline = lazy(() => import("../../Dashboard/Components/Timeline"));
const DocsApproval = lazy(() => import("../../Dashboard/Components/documents-approval/DocsApproval"));
const BOM = lazy(() => import("../../Dashboard/Components/production-section/BOM"));
const BOMApproval = lazy(() => import("../../Dashboard/Components/production-section/BOMApproval/BOMApproval"));
const Production = lazy(() => import("../../Dashboard/Components/production-section/Production"));
const NewWorkOrder = lazy(() => import("../../Dashboard/Components/production-section/NewWorkOrder"));
const CreateBillMaterial = lazy(() => import("../../Dashboard/Components/production-section/CreateBillMaterial"));
const PreviewBillMaterial = lazy(() => import("../../Dashboard/Components/production-section/PreviewBillMaterial"));
const QueryCollection = lazy(() => import("../../Dashboard/Components/query/QueryCollection"));
const RequestQueryCollection = lazy(() => import("../../Dashboard/Components/demoQueryCollection/RequestQueryCollection"));
const NewsLetters = lazy(() => import("../../Dashboard/Components/newsLetters/NewsLetters"));
const BatchCode = lazy(() => import("../../Dashboard/Components/BatchCode/BatchCode"));
const InventoryServices = lazy(() => import("../../Dashboard/Components/Documents/Services/inventory-services/InventoryServices"));
const DocumentServices = lazy(() => import("../../Dashboard/Components/Documents/Services/document-services/DocumentServices"));
const ViewProduction = lazy(() => import("../../Dashboard/Components/production-section/ViewProduction"));
const MaterialPlanning = lazy(() => import("../../Dashboard/Components/material-planning/MaterialPlanning"));
const MinimumStockPlanningTable = lazy(() => import("../../Dashboard/Components/material-planning/MinimumStockPlanningTable"));
const OrderPlanningTable = lazy(() => import("../../Dashboard/Components/material-planning/OrderPlanningTable"));
const BOMBasedPlanningTable = lazy(() => import("../../Dashboard/Components/material-planning/BOMBasedPlanningTable"));

interface IMainInterface {
  loginData: any;
  notifications: any;
  getNotifications: Function;
}

type AccessType = "create" | "view" | "edit" | "delete";

export interface IRolePermission {
  feature: string;
  subFeature: {
    name: string;
    create: number;
    view: number;
    edit: number;
    delete: number;
  }[];
};

export const hasAccess = (
  rolePermissions: IRolePermission[],
  featureName: string,
  subfeatureName: string,
  accessType: AccessType,
  role: any
): boolean => {
  if (role === 1 || role === 2) return true; // Admin has access to everything
  // access here loginData
  const feature = rolePermissions?.find((f: any) => f.feature === featureName);
  if (!feature) return false;

  const sub = feature.subFeature?.find((sf: any) => sf.name === subfeatureName || (subfeatureName === "Categories" && sf.name === "Category") || (subfeatureName === "Category" && sf.name === "Categories"));
  if (!sub) return false;

  return sub[accessType] === 1;
};


const Main: React.FC<IMainInterface> = ({
  loginData,
  notifications,
  getNotifications,
}) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSideBarOpen, setIsSideBarOpen] = useState<string[]>([]);
  const currentYear = new Date().getFullYear();
  const [userData, setUserData] = useState<any>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [collapsed, setCollapsed] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 768;
      setIsDesktop(desktop);
      if (!desktop) {
        setCollapsed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  useEffect(() => {
    getNotifications({ companyId: loginData.data.companyId });
    setUserData(jwtDecode(loginData?.data?.token));
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        isNavOpen &&
        window.innerWidth <= 768 && // Only apply on mobile
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        setIsNavOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isNavOpen]);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleLogout = () => {
    Persistor.purge().then(() => {
      localStorage.removeItem("easemargin");
      window.location.href = "/login";
    });
  };

  const menuItems = notifications?.length
    ? notifications.map((notification: any) => ({
      key: notification.id,
      label: (
        <div className="item-notification">
          <span className="avatar-wrapper">
            <Avatar
              style={{ backgroundColor: "#0167ff" }}
              icon={<UserOutlined />}
            />
          </span>
          <div className="notification-user-action">
            <div className="notification-text">
              {notification.notification}
            </div>
          </div>
          <div className="dismiss-icon">
            <CloseOutlined />
          </div>
        </div>
      ),
    }))
    : [
      {
        key: "noNotifications",
        label: (
          <div className="noNotifications">
            <img src={noNotification} alt="No Notifications" width="48" height="48" loading="lazy" />
          </div>
        ),
      },
    ];

  const handleOpenChange = (keys: string[]) => {
    const latestOpenKey = keys.find((key) => !isSideBarOpen.includes(key));
    setIsSideBarOpen(latestOpenKey ? [latestOpenKey] : []);
  };

  const handleMenuClick = (data: any) => {
    // setSiderViewVisble(true)
    navigate("/" + data.key);
  };

  const getSideNavItems = () => {
    let permissionArray: { feature: any; subFeature: { name: any; create: any; view: any; edit: any; delete: any; }[]; }[] = [];
    loginData?.data?.permissions.forEach((permission: any) => {
      const existingFeature = permissionArray.find(
        (item) => item.feature === permission.feature
      );

      const subFeatureObj = {
        name: permission.subfeature,
        create: permission.create,
        view: permission.view,
        edit: permission.edit,
        delete: permission.delete,
      };

      if (existingFeature) {
        existingFeature.subFeature.push(subFeatureObj);
      } else {
        permissionArray.push({
          feature: permission.feature,
          subFeature: [subFeatureObj],
        });
      }
    });
    let sideNavMenus = [
      {
        key: "dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
      },
      {
        key: "buyer_supplier",
        icon: <BankOutlined />,
        label: "Companies",
      },
      {
        key: "inventory_management",
        icon: <GoldOutlined />,
        label: "Inventory",
        children: [
          {
            key: "items",
            icon: <AppstoreOutlined />,
            label: "Items",
          },
          {
            key: "stores",
            icon: <ShopOutlined />,
            label: "Stores",
          },
          {
            key: "batchcode",
            icon: <ShopOutlined />,
            label: "Batch/Bar Code",
          },
          {
            key: "inventoryapproval",
            icon: <ShopOutlined />,
            label: "Inventory Approval",
          },
        ],
      },
      {
        key: "sales/documents",
        icon: <TruckOutlined />,
        label: "Sales",
        // children: [
        //   {
        //     key: "sales/documents",
        //     icon: <FileTextOutlined />,
        //     label: "Documents",
        //   },
        //   // {
        //   //   key: "timeline",
        //   //   icon: <ClockCircleOutlined />,
        //   //   label: "Timeline",
        //   // },
        // ],
      },
      {
        key: "purchase/documents",
        icon: <TruckOutlined />,
        label: "Purchase",
        // children: [
        //   {
        //     key: "purchase/documents",
        //     icon: <FileTextOutlined />,
        //     label: "Documents",
        //   },
        //   // {
        //   //   key: "purchase_timeline",
        //   //   icon: <ClockCircleOutlined />,
        //   //   label: "Timeline",
        //   // },
        // ],
      },
      {
        key: "services",
        icon: <AppstoreOutlined />,
        label: "Services",
        children: [
          {
            key: "service/documentServices",
            icon: <ShopOutlined />,
            label: "Service Order",
          },
          {
            key: "service/documentServicesConfirmation",
            icon: <ShopOutlined />,
            label: "Service Confirmation",
          },
          {
            key: "listOfServices",
            icon: <BuildOutlined />,
            label: "List of Services",
          },
        ],
      },
      {
        key: "docs_approval",
        icon: <FileDoneOutlined />,
        label: "Docs Approval",
      },
      {
        key: "material_planning",
        icon: <ScheduleOutlined />,
        label: "Material Planning"
      },
      {
        key: "production_section",
        icon: <ToolOutlined />,
        label: "Production",
        children: [
          {
            key: "bill-of-material",
            icon: <FileTextOutlined />,
            label: "Bill of material",
          },
          {
            key: "bom_approval",
            icon: <CheckCircleOutlined />,
            label: "BOM Approval",
          },
          {
            key: "production",
            icon: <BuildOutlined />,
            label: "Production",
          },
        ],
      },
      // {
      //   key: "integrations",
      //   icon: <LinkOutlined />,
      //   label: "Integration",
      // },
      {
        key: "transaction",
        icon: <DollarCircleOutlined />,
        label: "Transaction",
        children: [
          {
            key: "sales_transaction",
            icon: <ProjectOutlined />,
            label: "Receivable",
          },
          {
            key: "purchase_transaction",
            icon: <TruckOutlined />,
            label: "Payable",
          },
        ],
      },
      {
        key: "gate_entries",
        icon: <FileDoneOutlined />,
        label: "Gate Entries"
      },
      {
        key: "reports",
        icon: <LineChartOutlined />,
        label: "Reports",
      }
    ];

    if (userData?.role === 1) {
      sideNavMenus.push(
        {
          key: "settings",
          icon: <SettingOutlined />,
          label: "Settings",
          children: [
            {
              key: "general",
              icon: <ToolOutlined />,
              label: "General",
            },
            {
              key: "user_management",
              icon: <UserOutlined />,
              label: "Users",
            },
          ],
        },
      )
    } else if (userData?.role === 2) {
      sideNavMenus.push(
        {
          key: "settings",
          icon: <SettingOutlined />,
          label: "Settings",
          children: [
            {
              key: "general",
              icon: <ToolOutlined />,
              label: "General",
            },
            {
              key: "user_management",
              icon: <UserOutlined />,
              label: "Users",
            },
          ],
        },
        { key: "manage_blogs", icon: <BookOutlined />, label: "Blogs" },
        { key: "comments", icon: <CommentOutlined />, label: "Comments" },
        { key: "query", icon: <QuestionCircleOutlined />, label: "Query" },
        {
          key: "demoRequest",
          icon: <MessageOutlined />,
          label: "Demo Request",
        },
        { key: "newsLetters", icon: <MailOutlined />, label: "News Letter" },
        { key: "delete-company-data", icon: <DeleteOutlined />, label: "Delete Company Data" }
      );
    } else {
      sideNavMenus.push(
        {
          key: "settings",
          icon: <SettingOutlined />,
          label: "Settings",
          children: [
            {
              key: "general",
              icon: <ToolOutlined />,
              label: "General",
            },
          ],
        },
      );
    }

    const enhanceNavItemsWithLinks = (items: any[]): any[] => {
      return items.map((item) => {
        if (item.children) {
          return {
            ...item,
            children: enhanceNavItemsWithLinks(item.children),
          };
        }
        return {
          ...item,
          label: <Link to={`/${item.key}`}>{item.label}</Link>,
        };
      });
    };

    return enhanceNavItemsWithLinks(sideNavMenus);
  };

  const renderComponents = () => {
    if (window.location.href.includes("buyer_supplier")) {
      return <BuyerSupplier />;
    }
    if (window.location.href.includes("storeWiseItems") && checkAuth()) {
      return <StoreWiseItems />
    }
    if (window.location.href.includes("categoryWiseItems") && checkAuth()) {
      return <CategoryWiseItems />
    }
    if (window.location.href.includes("stockAgeingItems") && checkAuth()) {
      return <StockAgeingItems />
    }
    if (window.location.href.includes("stockLevelAnalysisItems") && checkAuth()) {
      return <StockLevelAnalysisItems />
    }
    if (window.location.href.includes("outOfStockItems") && checkAuth()) {
      return <OutOfStockItems />
    }
    if (window.location.href.includes("fastSlowMovingItems") && checkAuth()) {
      return <FastSlowMovingItems />
    }
    if (window.location.href.includes("onTimeDelayProductionItems") && checkAuth()) {
      return <OnTimeDelayProductionItems />
    }
    if (window.location.href.includes("workOrderStatusItems") && checkAuth()) {
      return <WorkOrderStatusItems />
    }
    if (window.location.href.includes("salesDashboardDetails") && checkAuth()) {
      return <SalesDashboardDetails />
    }
    if (window.location.href.includes("dashboard") && checkAuth()) {
      return <Dashboard />;
    }
    if (window.location.href.includes("settings")) {
      return <Settings />;
    }
    if (window.location.href.includes("user_management")) {
      return <Usermanagement />;
    }
    if (window.location.href.includes("team_management")) {
      return <Teammanagement />;
    }
    if (window.location.href.includes("general")) {
      return <ProfileManagement />;
    }
    if (window.location.href.includes("items")) {
      return <ItemManagement />;
    }
    if (window.location.href.includes("batchcode")) {
      return <BatchCode />;
    }
    if (window.location.href.includes("inventoryapproval")) {
      return <InventoryApproval />;
    }
    if (window.location.href.includes("delete-company-data")) {
      return <DeleteCompanyData />;
    }
    if (window.location.href.includes("inventoryPreview")) {
      return <InventoryPreview />;
    }
    if (window.location.href.includes("listOfServices")) {
      return <InventoryServices />;
    }
    if (window.location.href.includes("documentServices")) {
      return <DocumentServices />;
    }
    if (window.location.href.includes("documentServicesConfirmation")) {
      return <DocumentServices />;
    }
    if (window.location.href.includes("stores")) {
      return <StoresManagement />;
    }
    if (window.location.href.includes("batchcode")) {
      return <BatchCode />;
    }
    if (window.location.href.includes("manage_blogs")) {
      return <ManageBlogs />;
    }
    if (window.location.href.includes("comments")) {
      return <CommentsCollections />;
    }
    if (window.location.href.includes("query")) {
      return <QueryCollection />;
    }
    if (window.location.href.includes("demoRequest")) {
      return <RequestQueryCollection />;
    }
    if (window.location.href.includes("newsLetters")) {
      return <NewsLetters />;
    }
    if (window.location.href.includes("create_document")) {
      return <CreateDocument />;
    }
    if (window.location.href.includes("create_gate_entry")) {
      return <CreateGateEntry />;
    }
    if (window.location.href.includes("update_document")) {
      return <CreateDocument />;
    }
    if (window.location.href.includes("create_bill_of_material")) {
      return <CreateBillMaterial />;
    }
    if (window.location.href.includes("previewBOM")) {
      return <PreviewBillMaterial />;
    }
    if (window.location.href.includes("previewDocument")) {
      return <PreviewDocument />;
    }
    if (window.location.href.includes("servicepreviewDocument")) {
      return <ServiceDocument />;
    }
    if (window.location.href.includes("documents")) {
      return <Documents />;
    }
    if (window.location.href.includes("gate_entries")) {
      return <GateEntries />;
    }
    if (window.location.href.includes("previewGateEntry")) {
      return <PreviewGateEntry />;
    }
    if (window.location.href.includes("reports")) {
      return <Reports />;
    }
    if (window.location.href.includes("bill-of-material")) {
      return <BOM />;
    }
    if (window.location.href.includes("bom_approval")) {
      return <BOMApproval />;
    }
    if (window.location.href.includes("view_production")) {
      return <ViewProduction />;
    }
    if (window.location.href.includes("view-bulk-production")) {
      return <ViewBulkProduction />;
    }
    if (window.location.href.includes("production")) {
      return <Production />;
    }
    if (window.location.href.includes("new_work_order")) {
      return <NewWorkOrder />;
    }

    if (window.location.href.includes("docs_approval")) {
      return <DocsApproval />;
    }
    if (window.location.href.includes("integrations")) {
      return <Integrations />;
    }
    if (window.location.href.includes("sales_transaction")) {
      return <Transaction transactionType="Sales Transaction" />;
    }
    if (window.location.href.includes("purchase_transaction")) {
      return <Transaction transactionType="Purchase Transaction" />;
    }
    if (window.location.href.includes("timeline")) {
      return <Timeline timelineType="Sales" />;
    }
    if (window.location.href.includes("purchase_timeline")) {
      return <Timeline timelineType="Purchase" />;
    }
    if (window.location.href.includes("material_planning")) {
      return <MaterialPlanning />;
    }
    if (window.location.href.includes("order_planning_table")) {
      return <OrderPlanningTable />;
    }
    if (window.location.href.includes("minimum_stock_planning_table")) {
      return <MinimumStockPlanningTable />;
    }
    if (window.location.href.includes("bom_based_planning_table")) {
      return <BOMBasedPlanningTable />;
    }
  };

  const checkAuth = () => {
    return loginData?.data?.token ? true : false;
  };

  const items: MenuProps["items"] = [
    // {
    //   label: <span onClick={() => navigate("/general")}>General</span>,
    //   key: "0",
    // },
    {
      label: <span onClick={handleLogout}>Logout</span>,
      key: "2",
    },
  ];

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <div className="">
      <Layout className="mainLayout">
        <Header
          className="header"
          style={{
            alignItems: "center",
            position: "sticky",
          }}
        >
          <div className="flex ">
            <MenuOutlined className="hamburgur hide" onClick={toggleNav} />
            <img
              src={logo}
              alt="Ease Margin"
              className="logo h-[20px]  md:h-[30px] md:w-[150px] md:ml-[-30px] ml-6 mt-1 "
              onClick={() => navigate("/dashboard")}
            />
          </div>
          <div>
            {/* <QuestionCircleOutlined style={{ color: "#FFFFFF" }} />
            <Dropdown
              menu={{
                items: menuItems,
                className: "menu-notification",
              }}
              trigger={["click"]}
              open={visible}
              onOpenChange={(flag) => setVisible(flag)}
            >
              <Badge
                count={notifications?.length}
                className="notificationCount"
              >
                <BellOutlined
                  style={{
                    color: "#FFFFFF",
                    marginLeft: "20px",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                />
              </Badge>
            </Dropdown> */}
            <Dropdown menu={{ items }} trigger={["click"]}>
              <a onClick={(e) => e.preventDefault()}>
                <UserOutlined
                  style={{
                    marginRight: "10px",
                    marginLeft: "20px",
                    color: "#FFFFFF",
                  }}
                />
                <span style={{ color: "#FFFFFF" }} className="dhide">
                  {loginData.data.email}
                </span>
              </a>
            </Dropdown>
          </div>
        </Header>

        <Layout>
          {/* <Sider
            ref={sidebarRef}
            className={`sideNav ${isNavOpen ? "active" : ""}`}
            width={250}
            style={{
              background: colorBgContainer,
              minHeight: "calc(100vh - 50px)",
              overflowY: "auto",
            }}
          > */}
          <Sider
            ref={sidebarRef}
            collapsible={isDesktop}
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            collapsedWidth={80}
            width={250}
            trigger={null}
            className={`sideNav ${isNavOpen ? "active" : ""}`}
            style={{
              background: colorBgContainer,
              minHeight: "calc(100vh - 50px)",
              overflowY: "auto"
            }}

          >

            {isDesktop && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: collapsed ? 'center' : 'flex-end',
                  cursor: 'pointer',
                  paddingTop: '14px',
                  paddingRight: collapsed ? '0px' : '10px'
                }}
                onClick={() => setCollapsed(!collapsed)}
              >
                {collapsed ? <MenuUnfoldOutlined color="#000000e0" /> : <MenuFoldOutlined color="#000000e0" />}
              </div>
            )}
            <Menu
              mode="inline"
              theme="light"
              defaultSelectedKeys={["1"]}
              openKeys={isSideBarOpen}
              onOpenChange={handleOpenChange}
              onClick={(elem: any) => {
                handleMenuClick(elem);
                setIsNavOpen(false);
              }}
              style={{
                borderRight: 0,
                paddingBottom: '50px',
              }}
              items={getSideNavItems()}
            />
          </Sider>

          {/* Main Content */}
          <Layout style={{ display: "flex", flexDirection: "column" }}>
            <Suspense>{renderComponents()}</Suspense>
          </Layout>
        </Layout>
      </Layout>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  loginData: state.api.login,
  notifications: state.api.getNotifications?.data,
});

const mapDispatchToProps = (dispatch: any) => ({
  getNotifications: (payload: any) => dispatch(getNotifications(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);

